export type UpdateKind =
  | 'notice'
  | 'followup'
  | 'warning'
  | 'clarification'
  | 'impugnation'
  | 'appeal';

export interface AiManagementUpdateBidding {
  id: number;
  notice_number: string | null;
  public_body: string | null;
  city: string | null;
  state: string | null;
}

export interface AiManagementUpdate {
  id: number;
  kind: UpdateKind;
  title: string;
  description: string | null;
  published_at: string;
  read: boolean;
  card_id: number;
  bidding: AiManagementUpdateBidding;
}

export interface AiManagementUpdatesPage {
  updates: AiManagementUpdate[];
  unread_count: number;
  total_entries: number;
  total_pages: number;
  current_page: number;
}

export const UPDATES_PER_PAGE = 10;

export const UNREAD_POLL_INTERVAL_MS = 60000;

export const UPDATE_FILTERS: { key: UpdateKind | 'todas'; label: string }[] = [
  { key: 'todas', label: 'Todas' },
  { key: 'notice', label: 'Edital/Anexo' },
  { key: 'followup', label: 'Acompanhamentos' },
  { key: 'warning', label: 'Avisos' },
  { key: 'clarification', label: 'Esclarecimentos' },
  { key: 'impugnation', label: 'Impugnações' },
  { key: 'appeal', label: 'Recursos' },
];

export const UPDATE_KIND_ICON: Record<UpdateKind, string> = {
  notice: 'attach_file',
  followup: 'description',
  warning: 'description',
  clarification: 'description',
  impugnation: 'description',
  appeal: 'description',
};
